import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * Inline tabs showing "Original" vs "What-If" content for an overridden node.
 * Renders inside InteractiveRoadmapNode when the node has an override.
 */
const WhatIfNodeCarousel = ({ originalNode, currentNode, softColor }) => {
  const [activeTab, setActiveTab] = useState('whatif');

  const cleanTitle = (title) => title ? title.split(/ at /i)[0].trim() : '';

  const displayNode = activeTab === 'original' ? originalNode : currentNode;

  return (
    <div className="mt-3 pt-3 border-t border-amber-200">
      {/* Tab Switcher */}
      <div className="flex gap-1 mb-3">
        <button
          onClick={(e) => { e.stopPropagation(); setActiveTab('whatif'); }}
          className={`px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wide transition-all ${
            activeTab === 'whatif'
              ? 'bg-amber-100 text-amber-700 border border-amber-300'
              : 'bg-slate-50 text-slate-400 border border-transparent hover:bg-slate-100'
          }`}
        >
          What-If
        </button>
        <button
          onClick={(e) => { e.stopPropagation(); setActiveTab('original'); }}
          className={`px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wide transition-all ${
            activeTab === 'original'
              ? 'bg-slate-200 text-slate-700 border border-slate-300'
              : 'bg-slate-50 text-slate-400 border border-transparent hover:bg-slate-100'
          }`}
        >
          Original
        </button>
      </div>

      {/* Content */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, x: activeTab === 'original' ? -10 : 10 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: activeTab === 'original' ? 10 : -10 }}
          transition={{ duration: 0.15 }}
          className="bg-slate-50 rounded-lg p-3"
        >
          <p className="text-[10px] uppercase font-bold text-slate-400 tracking-wide mb-1">
            {activeTab === 'original' ? 'Original Role' : 'What-If Scenario'}
          </p>
          <h5 className="font-bold text-sm text-slate-700 mb-1">
            {cleanTitle(displayNode?.title)}
          </h5>
          <p className="text-xs text-slate-500 line-clamp-2">
            {displayNode?.description}
          </p>
          {displayNode?.salary_range && (
            <div className="mt-2 text-xs font-semibold" style={{ color: softColor }}>
              ${(displayNode.salary_range.min / 1000).toFixed(0)}k - ${(displayNode.salary_range.max / 1000).toFixed(0)}k
            </div>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default WhatIfNodeCarousel;
